import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { Card, CardBody, CardHeader } from "react-bootstrap";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import { formatDate } from "../../../utils/Helper";
import { Dialog } from "primereact/dialog";

interface IProps {
    providerConnections?: any,
    t?: any,
};

function AlpProfile(props: IProps) {
    const { t, providerConnections } = props;
    const [selectedProvider, setSelectedProvider] = useState<any>(null);

    const emilFreyConnected = !!providerConnections?.emil_frey?.connected;
    const vehicleLogisticsConnected = !!providerConnections?.vehicle_logistics?.connected;
    const providerRows = [
        {
            key: 'emil_frey',
            label: t('emil frey'),
            data: providerConnections?.emil_frey,
            connected: emilFreyConnected,
        },
        {
            key: 'vehicle_logistics',
            label: t('vehicle logistics'),
            data: providerConnections?.vehicle_logistics,
            connected: vehicleLogisticsConnected,
        },
    ];

    const formatProviderDate = (value: any, subtractDay: boolean = false) => {
        if ( !value ) {
            return '-';
        }

        const date = subtractDay ? moment(value).subtract('day', 1) : moment(value);
        return formatDate(date);
    };

    const ProviderDetailRow = ({ label, value }: { label: string, value: any }) => (
        <div className="d-flex justify-content-between align-items-start border-bottom py-2 gap-3">
            <span className="text-muted small">{ label }</span>
            <strong className="text-end small">{ value || '-' }</strong>
        </div>
    );

    return (
        <Card className={ 'mb-3' }>
            <CardHeader className={ "bg-body-tertiary" }>
                <h4 className="card-title">{ t('provider') } { t('connections') }</h4>
            </CardHeader>
            <CardBody>
                { providerRows.map((provider) => (
                    <button
                        key={ provider.key }
                        type="button"
                        className={ "d-flex justify-content-between align-items-center w-100 border rounded-3 bg-white px-3 py-2 mb-2 text-start" }
                        style={ { width: '100%' } }
                        onClick={ () => setSelectedProvider(provider) }
                    >
                        <span>
                            { provider.label }
                            <i className="fas fa-info-circle text-muted ms-2" />
                        </span>
                        <span className={ provider.connected ? 'badge bg-success' : 'badge bg-secondary' }>
                            { provider.connected ? t('connected') : t('not connected') }
                        </span>
                    </button>
                )) }

                <Dialog
                    header={ selectedProvider?.label ?? t('provider') }
                    visible={ !!selectedProvider }
                    style={ { width: '520px', maxWidth: '95vw' } }
                    onHide={ () => setSelectedProvider(null) }
                    draggable={ false }
                >
                    { selectedProvider && (
                        <div>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <span className="text-muted">{ t('connection status') }</span>
                                <span className={ selectedProvider.connected ? 'badge bg-success' : 'badge bg-secondary' }>
                                    { selectedProvider.connected ? t('connected') : t('not connected') }
                                </span>
                            </div>

                            <ProviderDetailRow label={ t('active') } value={ selectedProvider.data?.is_active ? t('yes') : t('no') } />
                            <ProviderDetailRow label={ t('token expires at') } value={ formatProviderDate(selectedProvider.data?.token_expires_at, true) } />
                            <ProviderDetailRow label={ t('provider user id') } value={ selectedProvider.data?.provider_user_id } />
                            <ProviderDetailRow label={ t('identification number') } value={ selectedProvider.data?.identification_number } />
                            <ProviderDetailRow label={ t('email') } value={ selectedProvider.data?.email } />
                            <ProviderDetailRow label={ t('provider supplier id') } value={ selectedProvider.data?.provider_supplier_id } />
                            <ProviderDetailRow label={ t('provider supplier name') } value={ selectedProvider.data?.provider_supplier_name } />
                            <ProviderDetailRow label={ t('provider supplier email') } value={ selectedProvider.data?.provider_supplier_email } />
                            <ProviderDetailRow label={ t('created at') } value={ formatProviderDate(selectedProvider.data?.created_at) } />
                            <ProviderDetailRow label={ t('updated at') } value={ formatProviderDate(selectedProvider.data?.updated_at) } />
                        </div>
                    ) }
                </Dialog>
            </CardBody>
        </Card>
    );
}

AlpProfile.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,
};

export default withTranslation()(AlpProfile);
